import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../chequesSlice";
import { fetchChequeList, fetchChequeCustomersBySearch } from "../chequesThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";

const ChequesFilters = () => {
  const dispatch = useDispatch();
  const { filters, customers, customersLoading } = useSelector(
    (state) => state.cheques
  );

  const searchCustomers = useCallback(
    (text) => dispatch(fetchChequeCustomersBySearch(text)),
    [dispatch]
  );

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleGetList = () => {
    dispatch(fetchChequeList(filters));
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "all", display_text: "All" },
              { sale_id: "in", display_text: "In" },
              { sale_id: "out", display_text: "Out" },
            ]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("type", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Customer/Supplier</label>
          <SearchListAutoComplete
            entityType="customer"
            searchThunk={searchCustomers}
            resultSelector={(state) => state.cheques.customers} // 🔑 redux results
            onSelect={(obj) => handleFilterChange("from_acc_id", obj?.sale_id)}
            placeholder="Customer / Supplier"
            showAddNew={false}
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={6} style={{ paddingTop: "14px" }}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleGetList}
            block
          >
            Get List
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default ChequesFilters;
